import * as members from '../../privates/privateMembers';
import {validate} from '../../privates/validations/validation';
import {runValidationsAfterChange} from '../../privates/validationsService/validationsService';
import * as Utils from '../Utils';
import _ from 'lodash';

/**
 * @mixin CheckedMixin
 * @description Provides functionality for elements that can be be checked.
 * @memberof $w
 */
class CheckedMixin {
    /**
     * @member checked
     * @label property
     * @syntax
     * get checked(): boolean
     * set checked(value: boolean): void
     * @summary Sets or gets whether the element is checked or not.
     * @snippet [CheckedMixin-checked_get.es6=Get whether an element is checked]
     * @snippet [CheckedMixin-checked_set.es6=Set an element to be checked]
     * @type {external:Boolean}
     * @memberof $w.CheckedMixin
     * @instance
     */
    get checked () {
        return Utils.getData(this, 'checked') || false;
    }

  /**
   * @member checked
   * @memberof $w.CheckedMixin
   * @param {external:Boolean} checked
   */
    set checked (checked) {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const compType = members._type.get(this).compType;

        if (!validate({
                compType,
                functionName: 'checked',
                dataToValidate: {checked},
                compName: this.id
            })) {
            return;
        }

        runValidationsAfterChange(RMI, compId, checked);
        if (_.isNil(checked)){
            checked = false;
        }
        Utils.setData(this, { checked });
    }

}

export default CheckedMixin;
